import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=43a38bd7&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43a38bd7')) {
      api.createRecord('43a38bd7', component.options)
    } else {
      api.reload('43a38bd7', component.options)
    }
    module.hot.accept("./goods.vue?vue&type=template&id=43a38bd7&", function () {
      api.rerender('43a38bd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/goods/goods.vue"
export default component.exports